// External libraries
import React from 'react';

// Internal modules
import { WalletRow } from './WalletRow';
import type { CheckoutOption } from './types';

export type SingularWalletOptionProps = {
  wallet: CheckoutOption;
  onWalletClick: (wallet: CheckoutOption) => void;
  footer?: React.ReactNode;
};

export const SingularWalletOption = ({
  wallet,
  onWalletClick,
  footer,
}: SingularWalletOptionProps): React.ReactElement => (
  <React.Fragment>
    <li>
      <WalletRow wallet={wallet} onWalletClick={onWalletClick} />
    </li>
    {footer && <li>{footer}</li>}
  </React.Fragment>
);
